// ============================================================
// FILE: templates/index.js
// PURPOSE: Categories list + lazy loading
// Har category click pe sirf us category ki files load hongi
// ============================================================

export const categories = [
  {
    id: 'research',
    name: 'Research — Professor Emails',
    icon: '🔬',
    desc: 'PhD inquiry, research position, professor contact',
    templates: [
      { id: 'phd-inquiry',        name: 'PhD Research Position Request',  loader: () => import('./research/phd-inquiry') },
      { id: 'masters-inquiry',    name: 'Masters Research Inquiry',        loader: () => import('./research/masters-inquiry') },
      { id: 'cold-email',         name: 'Cold Email — No Open Position',   loader: () => import('./research/cold-email') },
      { id: 'research-assistant', name: 'Research Assistant Position',     loader: () => import('./research/research-assistant') },
      { id: 'professor-followup', name: 'Follow-up After First Email',     loader: () => import('./research/professor-followup') },
    ]
  },
//   {
//     id: 'scholarship',
//     name: 'Scholarship — Application Emails',
//     icon: '🏆',
//     desc: 'Chevening, DAAD, Fulbright, CSC and more',
//     templates: [
//       { id: 'chevening', name: 'Chevening Interest Email',    loader: () => import('./scholarship/chevening') },
//       { id: 'daad',      name: 'DAAD Application Inquiry',    loader: () => import('./scholarship/daad') },
//       { id: 'fulbright', name: 'Fulbright Application Email', loader: () => import('./scholarship/fulbright') },
//       { id: 'csc',       name: 'CSC China Scholarship',       loader: () => import('./scholarship/csc') },
//       { id: 'turkiye',   name: 'Türkiye Burslari Inquiry',    loader: () => import('./scholarship/turkiye') },
//     ]
//   },
    {
    id: 'internship',
    name: 'Internship — Application Emails',
    icon: '💼',
    desc: 'Research and industry internship applications',
    templates: [
      { id: 'research-internship', name: 'Research Internship Request', loader: () => import('./internship/research-internship') },
      { id: 'industry-internship', name: 'Industry Internship Email',   loader: () => import('./internship/industry-internship') },
      { id: 'summer-program',      name: 'Summer Research Program',     loader: () => import('./internship/summer-program') },
    ]
  },
  {
    id: 'recommendation',
    name: 'Recommendation — Request Emails',
    icon: '📬',
    desc: 'Recommendation letter request templates',
    templates: [
      { id: 'university-request',  name: 'University Recommendation',  loader: () => import('./recommendation/university-request') },
      { id: 'scholarship-request', name: 'Scholarship Recommendation', loader: () => import('./recommendation/scholarship-request') },
      { id: 'employer-request',    name: 'Employer Reference Request', loader: () => import('./recommendation/employer-request') },
    ]
  },
  {
    id: 'followup',
    name: 'Follow-up Emails',
    icon: '🔄',
    desc: 'Follow-up after applications and interviews',
    templates: [
      { id: 'no-reply',          name: 'Follow-up After No Reply',     loader: () => import('./followup/no-reply') },
      { id: 'after-interview',   name: 'Thank You After Interview',    loader: () => import('./followup/after-interview') },
      { id: 'acceptance',        name: 'Acceptance Confirmation',      loader: () => import('./followup/acceptance') },
      { id: 'scholarship-status',name: 'Scholarship Status Follow-up', loader: () => import('./followup/scholarship-status') },
    ]
  },
];